import { Component, type ReactNode } from "react";
import { Link, useLocation } from "react-router-dom";
import { RefreshCw, House, WifiOff } from "lucide-react";

class Boundary extends Component<{ children: ReactNode; resetKey: string }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }

  componentDidUpdate(previous: Readonly<{ children: ReactNode; resetKey: string }>) {
    if (this.state.failed && previous.resetKey !== this.props.resetKey) {
      this.setState({ failed: false });
    }
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="fe-app min-h-screen flex items-center justify-center p-5">
        <section className="fe-surface rounded-3xl border p-8 max-w-lg text-center" role="alert">
          <WifiOff className="mx-auto mb-5 text-[#526a2e]" size={36} aria-hidden="true" />
          <h1 className="text-2xl font-bold">화면을 불러오지 못했어요</h1>
          <p className="my-4 text-sm leading-7 text-gray-600">네트워크 연결을 확인하고 다시 시도해 주세요. 새로고침하면 아직 저장하지 않은 입력은 사라질 수 있어요.</p>
          <div className="flex flex-wrap justify-center gap-3">
            <button type="button" className="fe-button fe-button-dark" onClick={() => window.location.reload()}><RefreshCw size={16} /> 다시 불러오기</button>
            <Link to="/" className="fe-button"><House size={16} /> 홈으로</Link>
          </div>
        </section>
      </div>
    );
  }
}

export function PageErrorBoundary({ children }: { children: ReactNode }) {
  const { pathname } = useLocation();
  return <Boundary resetKey={pathname}>{children}</Boundary>;
}
